import React, { createRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './Offerings.module.css';

const propTypes = {
  offering: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    description: PropTypes.element,
  }).isRequired,
  onToggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

const defaultProps = {
  isOpen: false,
};

const OfferingBlock = props => {
  const { offering, onToggle, isOpen } = props;
  const offeringBody = createRef();
  const [bodyHeight, setBodyHeight] = useState(0);

  useEffect(() => {
    setBodyHeight(isOpen ? offeringBody.current.scrollHeight : 0);
  }, [isOpen]);

  return (
    <div>
      <button
        className={classnames([
          styles.offeringBlock_header,
          styles[`offeringBlock_header_${offering.id}`],
        ])}
        onClick={() => onToggle(offering.id)}
      >
        {offering.title}
      </button>

      <div
        className={styles.offeringBlock_body}
        ref={offeringBody}
        style={{ height: `${bodyHeight}px` }}
      >
        <div className={styles.offeringBlock_description}>
          {offering.description}
        </div>
      </div>
    </div>
  );
};

OfferingBlock.propTypes = propTypes;
OfferingBlock.defaultProps = defaultProps;

export default OfferingBlock;
